import React from "react";
import clsx from 'clsx';
import { NavLink, matchPath, withRouter } from "react-router-dom";
import { makeStyles } from '@material-ui/styles';

import { compose } from 'redux';

import I18n from "../../../../base/i18n.js.jsx";
import Routes from "../../../routes.js.jsx";

const blockStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    marginBottom: "38px",
    justifyContent: "space-between",
    ['@media (max-width: 768px)']: {
      flexDirection: "column",
      marginBottom: "24px",
    }
  },
  navLink: {
    borderBottom: "1px solid transparent",
    color: theme.palette.grayText,
    fontSize: "20px",
    display: "flex",
    alignItems: "flex-start",
    lineHeight: "1",
    margin: "0",
    padding: "18px 0",
    textDecoration: "none",
    textTransform: "uppercase",
    "&:hover": {
      borderColor: theme.palette.grayDivider
    },
    ['@media (max-width: 768px)']: {
      borderLeft: "1px solid transparent",
      borderBottom: "none",
      fontSize: "13px",
      margin: "4px 0 4px -6px",
      padding: "3px 0 3px 6px"
    }
  },
  navLinkActive: {
    borderColor: theme.palette.blueMain,
    "&:hover": {
      borderColor: theme.palette.blueMain
    }
  }
}));

const allowedPaths = {
  personalInfo: [Routes.profilePersonalInfo()],
  questionnaire: [Routes.profileQuestionnaire()],
  paymentMethod: [Routes.profilePaymentMethod()]
}

const items = [
  {
    displayName: I18n.t("web.page.profile.navigation.personal_info"),
    name: "personalInfo",
    url: Routes.profilePersonalInfo()
  },
  {
    displayName: I18n.t("web.page.profile.navigation.questionnaire"),
    name: "questionnaire",
    url: Routes.profileQuestionnaire()
  },
  {
    displayName: I18n.t("web.page.profile.navigation.payment_method"),
    name: "paymentMethod",
    url: Routes.profilePaymentMethod()
  }
]

const NavBlock = props => {
  const classes = blockStyles();
  const { history, className, needReplace = false } = props;

  const itemMatched = item => {
    let matched = false;
    (allowedPaths[item.name] || []).forEach((path) => {
      let match = matchPath(window.location.pathname, {
        path: path,
        exact: true,
        strict: false
      });
      if(match && match.isExact) {
        matched = true;
      }
    })
    return matched;
  }

  const onClick = (event, url) => {
    if(!needReplace) {
      return;
    }
    event.preventDefault();
    history.replace(url);
  }

  return(
    <div className = { clsx(classes.root, className) }>
      { items.map(item => {
        return <NavLink activeClassName = { classes.navLinkActive }
                        className = { classes.navLink }
                        key = { item.name }
                        to = { item.url }
                        isActive = { () => {
                          return itemMatched(item);
                        } }
                        onClick = { (event) => onClick(event, item.url) }>
                { item.displayName }
              </NavLink>
      }) }
    </div>
  )
}

export default compose(withRouter)(NavBlock);
